var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "icon-columns__block" }, [
    _c("img", {
      directives: [
        {
          name: "lazy",
          rawName: "v-lazy",
          value: _vm.iconUrl,
          expression: "iconUrl",
        },
      ],
      staticClass: "icon-columns__icon",
      attrs: { alt: _vm.iconAlt },
    }),
    _c("h3", { staticClass: "icon-columns__block-title" }, [
      _vm._v(_vm._s(_vm.title)),
    ]),
    _vm.info
      ? _c(
          "p",
          { staticClass: "icon-columns__block-info", class: _vm.infoClass },
          [_vm._v(_vm._s(_vm.info))]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }